import { render } from "./FeedbacksScreen.vue?vue&type=template&id=6bf851ed&scoped=true"
import script from "./FeedbacksScreen.vue?vue&type=script&lang=js"
export * from "./FeedbacksScreen.vue?vue&type=script&lang=js"

import "./FeedbacksScreen.vue?vue&type=style&index=0&id=6bf851ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf851ed"]])

export default __exports__